define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var core = require('core');
    var Class = require('Class');
    var utils = require('utils');
    var _ = require('underscore');
    var server = require('server');
    var scrollManager = require('managers/scroll.manager');

    module.exports = Class.create({
        initialize: function(options) {
            this.paySafeInstance = {};
            this.options = options;
            this.bodyScrollLockId = utils.guid();
            this.updatePaysafeIntegrationScript();
        },

        updatePaysafeIntegrationScript: function() {
            this.removePaysafeScript();
            this.addPaysafeScript();
        },

        removePaysafeScript: function() {
            $('.paysafe-script').remove();
        },

        addPaysafeScript: function() {
            var script = document.createElement('script');

            script.src = this.options.url;
            script.type = 'text/javascript';
            script.classList.add('paysafe-script');
            script.onload = this.initiatePaysafe.bind(this);

            $('head').append(script);
        },

        initiatePaysafe: function() {
            if (!window.paysafe) {
                core.error('paysafe API is unavailable in window');

                return;
            }

            const postData = this.options.postData || {};
            const paysafeoptions = {
                displayPaymentMethods: [postData.displayPaymentMethods],
                environment: postData.environment,
                merchantRefNum: postData.merchantRefNum,
                currency: postData.currencyCode,
                amount: parseFloat(postData.amount),
                singleUseCustomerToken: postData.singleUseCustomerToken,
                paymentMethodDetails: { [postData.displayPaymentMethods]: {} },
                billingAddress: {
                    zip: postData.ZIP,
                    country: postData.COUNTRY_CODE,
                    city: postData.CITY,
                    street: postData.ADDRESS
                },
                customer: {
                    lastName: postData.LAST_NAME,
                    firstName: postData.FIRST_NAME,
                    email: postData.EMAIL,
                    phone: postData.PHONE,
                    dateOfBirth: this.getDateOfBirth(postData.BIRTH_DATE)
                }
            };

            // each parameter below should be added into paysafeoptions object only if present
            if (postData.simulator) {
                paysafeoptions.simulator = postData.simulator;
            }

            if (postData.STATE) {
                paysafeoptions.billingAddress.state = postData.STATE;
            }

            if (postData.consumerId) {
                paysafeoptions.paymentMethodDetails[postData.displayPaymentMethods].consumerId = postData.consumerId;
            }

            if (postData.accountId) {
                paysafeoptions.paymentMethodDetails[postData.displayPaymentMethods].accountId = postData.accountId;
            }

            switch (postData.displayPaymentMethods) {
                case 'sightline':
                    if (postData.last4ssn) {
                        paysafeoptions.paymentMethodDetails[postData.displayPaymentMethods].last4ssn = postData.last4ssn;
                    }

                    break;
                case 'vippreferred':
                    if (postData.registrationId) {
                        paysafeoptions.paymentMethodDetails[postData.displayPaymentMethods].registrationId = postData.registrationId;
                    }

                    break;
                case 'skrill':
                    if (postData.emailSubject) {
                        paysafeoptions.paymentMethodDetails[postData.displayPaymentMethods].emailSubject = postData.emailSubject;
                    }

                    if (postData.emailMessage) {
                        paysafeoptions.paymentMethodDetails[postData.displayPaymentMethods].emailMessage = postData.emailMessage;
                    }

                    break;
                default:
                    break;
            }

            scrollManager.disableScrolling(this.bodyScrollLockId);

            window.paysafe.checkout.setup(postData.apiKey, paysafeoptions, this.onPaysafeResultCallback.bind(this), this.onPaysafeCloseCallback.bind(this));
        },

        getDateOfBirth: function(date) {
            if (!date || typeof date !== 'string') {
                return {};
            }

            var dateArr = date.split('-');

            return { day: parseInt(dateArr[2]), month: parseInt(dateArr[1]), year: parseInt(dateArr[0]) };
        },

        onPaysafeResultCallback: function(instance, error, result) {
            if (error || result?.token) {
                let errorMessage = error ? error.detailedMessage : 'missing paysafe token';

                if (typeof this.options.onPaysafeDepositError === 'function') {
                    this.options.onPaysafeDepositError(error);
                }

                core.error(errorMessage);
                scrollManager.enableScrolling(this.bodyScrollLockId);

                return;
            }

            this.paySafeInstance = instance;
            this.sendTokenToIMS(result.paymentHandleToken, result.customerOperation);
        },

        onPaysafeCloseCallback: function(stage) {
            switch (stage) {
                case "PAYMENT_HANDLE_REDIRECT":
                case "PAYMENT_HANDLE_NOT_CREATED":
                    if (typeof this.options.onPaysafeWindowClose === 'function') {
                        this.options.onPaysafeWindowClose();
                    }

                    break;
                case "PAYMENT_HANDLE_PAYABLE":
                case "PAYMENT_HANDLE_CREATED":
                default:
                    this.onSendTokenToIMSSuccess();

                    break;
            }

            scrollManager.enableScrolling(this.bodyScrollLockId);
        },

        sendTokenToIMS: function(paymentHandleToken, customerOperation) {
            var requestOptions = {
                ID: 35747,
                description: 'Deposit listener request',
                responses: [35748, 35749],
                correlationId: _.uniqueId('paysafe'),
                methodCode: this.options.methodCode,
                apmListenerRequestParameters: {
                    getParameters: [
                        {
                            value: paymentHandleToken,
                            key: "paymentHandleToken"
                        },
                        {
                            value: this.options.transactionCode,
                            key: "pp"
                        }
                    ]
                }
            };

            if (customerOperation) {
                requestOptions.apmListenerRequestParameters.getParameters
                    .push({
                        key: 'customerOperation',
                        value: customerOperation
                    });
            }

            server.send(requestOptions)
                .done(this.onSendTokenToIMSSuccess.bind(this))
                .fail(this.onSendTokenToIMSError.bind(this));
        },

        onSendTokenToIMSSuccess: function(data) {
            if (data?.data?.transactionData?.status === 'declined') {
                this.onSendTokenToIMSError(data);

                return;
            }

            if (typeof this.options.onPaysafeDepositSuccess === 'function') {
                this.options.onPaysafeDepositSuccess(data);
            }

            this.paySafeInstance?.isOpen && this.paySafeInstance?.close();
        },

        onSendTokenToIMSError: function(data) {
            if (typeof this.options.onPaysafeDepositError === 'function') {
                this.options.onPaysafeDepositError(data);
            }

            this.paySafeInstance?.isOpen && this.paySafeInstance?.close();
        }
    });
});
